import React from "react";
import {Provider} from "react-redux";
import {createReduxStore} from "./redux/store";
import PropTypes from "prop-types";

import PackagesSalesModule from "./packagesSalesModule";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";

const PackagesSales = props => (
  <Provider store={createReduxStore("packagesSalesModule")}>
    <ErrorBoundary moduleName="packagesSalesModule" {...props.notifications}>
      <PackagesSalesModule currentUser={props.params} chartName={props.chartName}/>
    </ErrorBoundary>
  </Provider>
);

PackagesSales.propTypes = {
  params: PropTypes.object,
  chartName: PropTypes.string,
};

export default PackagesSales;
